

  let teradekRequirements = {
    "10-0995-2G": {
      requires: [
        {tags: ["sdi_cable"], quantity: 2, href: "", message: "You need SDI cable(s)"}
        ,{tags: ["2pin_cable"], quantity: 1, href: "", message: "You need 2pin cable(s)"}
      ]
    }
    ,"10-0995-1G": {
      requires: [
        {tags: ["sdi_cable"], quantity: 1, href: "", message: "You need SDI cable(s)"}
        ,{tags: ["2pin_cable"], quantity: 1, href: "", message: "You need 2pin cable(s)"}
      ]
    }
    ,"15-0008": {
      requires: [
        {tags: ["powercable"], quantity: 1, href: "teradek-rt?display=list&_=pf&pf_t_accessories=powercable", message: "You need power cable(s)"}
        ,{tags: ["cameracable"], quantity: 1, href: "teradek-rt?display=list&_=pf&pf_t_accessories=CameraCable", message: "You need camera cable(s)"}
        ,{tags: ["lensmotor"], quantity: 3, href: "teradek-rt?display=list&_=pf&pf_t_step_2_motors=lensmotor", message: "Control up to 3 motors", optional: true}
      ]
    }
    ,"15-0009": {
      requires: [
        {tags: ["powercable"], quantity: 1, href: "teradek-rt?display=list&_=pf&pf_t_accessories=powercable", message: "You need power cable(s)"}
        ,{tags: ["cameracable"], quantity: 1, href: "teradek-rt?display=list&_=pf&pf_t_accessories=CameraCable", message: "You need camera cable(s)"}
        ,{tags: ["lensmotor"], quantity: 3, href: "teradek-rt?display=list&_=pf&pf_t_step_2_motors=lensmotor", message: "Control up to 3 motors", optional: true}
      ]
    }
    ,"15-0012": {
      requires: [
        {tags: ["powercable"], quantity: 1, href: "teradek-rt?display=list&_=pf&pf_t_accessories=powercable", message: "You need power cable(s)"}
        ,{tags: ["cameracable"], quantity: 1, href: "teradek-rt?display=list&_=pf&pf_t_accessories=CameraCable", message: "You need camera cable(s)"}
        ,{tags: ["lensmotor"], quantity: 3, href: "teradek-rt?display=list&_=pf&pf_t_step_2_motors=lensmotor", message: "Control up to 3 motors", optional: true}
      ]
    }
    ,"15-0025": {
      requires: [
        {tags: ["motorcable"], quantity: 1, href: "teradek-rt?display=list&_=pf&pf_t_accessories=motorcable", message: "You need motor cable(s)"}
        ,{tags: ["controller", "wirelesscontroller", "wiredcontroller", "controller-deluxe"], quantity: 1, href:"teradek-rt?display=list&_=pf&pf_t_step_3_controllers=WirelessController&pf_t_step_3_controllers=WiredController", message: "Motor Controller(s)", optional: true, noQuantity: true}
      ]
    }
    ,"15-0030": {
      requires: [
        {tags: ["powercable"], quantity: 1, href: "teradek-rt?display=list&_=pf&pf_t_accessories=powercable", message: "You need power cable(s)"}
        ,{tags: ["cameracable"], quantity: 1, href: "teradek-rt?display=list&_=pf&pf_t_accessories=CameraCable", message: "You need camera cable(s)"}
        ,{tags: ["lensmotor"], quantity: 3, href: "teradek-rt?display=list&_=pf&pf_t_step_2_motors=lensmotor", message: "Control up to 3 motors", optional: true}
      ]
    }
    ,"15-0044": {
      requires: [
        {tags: ["motorcable"], quantity: 1, href: "teradek-rt?display=list&_=pf&pf_t_accessories=motorcable&", message: "You need motor cable(s)"}
        ,{tags: ["controller", "wirelesscontroller", "wiredcontroller", "controller-deluxe"], quantity: 1, href:"teradek-rt?display=list&_=pf&pf_t_step_3_controllers=WirelessController&pf_t_step_3_controllers=WiredController", message: "Motor Controller(s)", optional: true, noQuantity: true}
      ]
    }
    ,"10-CTRL3": {
      requires: [
        {tags: ["lensmotor"], quantity: 2, href:"teradek-rt?display=list&_=pf&pf_t_step_2_motors=lensmotor", message: "Control up to 2 more motors", optional: true}
      ]
    }
    ,"10-0986": {
      requires: [
        {tags: ["rx"], quantity: 1, href:"bolt?_=pf&pf_t_tags=RX", message: "Receiver", optional: true}
      ]
    }
    ,"14-0445": {
      requires: [
        {tags: ["director's monitor cages"], quantity: 1, href:"wooden-camera?_=pf&pf_t_accessories=Director%27s%20Monitor%20Cages", message: "Mounting Cage", optional: true}
        ,{tags: ["TX"], quantity: 1, href:"bolt?_=pf&pf_t_tags=TX", message: "Transmitter", optional: true}
      ]
    }
    ,"15-0043": {
      requires: [
        {tags: ["lensmapping"], quantity: 1, href:"teradek-rt?_=pf&pf_t_accessories=lensmapping", message: "Lens Mapping", optional: true}
      ]
    }
  }
  
  let smallHDRequirements = {
    "MON-FOCUS7": {
      requires: [
        {tags: ["TX"], quantity: 1, href:"bolt?_=pf&pf_t_tags=TX", message: "Transmitter", optional: true}
      ]
    }
    ,"14-0469": {
      requires: [
        {tags: ["TX"], quantity: 1, href:"bolt?_=pf&pf_t_tags=TX", message: "Transmitter", optional: true}
      ]
    }
    ,"14-0454": {
      requires: [
        {tags: ["TX"], quantity: 1, href:"bolt?_=pf&pf_t_tags=TX", message: "Transmitter", optional: true}
      ]
    }
    ,"14-0453": {
      requires: [
        {tags: ["RX"], quantity: 1, href:"bolt?_=pf&pf_t_tags=RX", message: "Receiver", optional: true}
      ]
    }
  }

  let allRequirements = {
    ...teradekRequirements,
    ...smallHDRequirements
  }